import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  IllustrationSvg,
  SkyBackdrop,
  SlopeSurface,
  WalkerFigure,
  WarningDot,
} from './shared';

export default function WalkingImpossibleIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.impossible;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="Yürüyüş çok zor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={50} endY={14} accent={accent} />
      <WalkerFigure cx={40} cy={18} posture="impossible" primary={primaryColor} />
      <WarningDot x={58} y={10} />
      <g stroke={ILLUSTRATION_PALETTE.impossible} strokeWidth="1" strokeLinecap="round" opacity="0.6">
        <line x1="52" y1="18" x2="56" y2="22" />
        <line x1="56" y1="18" x2="52" y2="22" />
      </g>
    </IllustrationSvg>
  );
}
